<main>
  <div class="grid-max-width center grid-col-12 no-row-gap">
    <div class="col-f md-col-3-10 xl-col-4-9">
      <h1 class="pr-large-t pr-small-b">{{ 'MMB.checkIn.confirmation.title' | finLocalization }}</h1>
      <p class="font-body-1">{{ 'MMB.checkIn.confirmation.description' | finLocalization }}</p>

      <h2 class="font-heading-4 ps-xxlarge-t ps-xsmall-b">
        {{ 'MMB.checkIn.confirmation.subTitle' | finLocalization }}
      </h2>
      <p class="font-body-1">{{ 'MMB.checkIn.confirmation.subDescription' | finLocalization }}</p>

      @if ((travelerEligibleForBoardingPassExists$ | async) === true) {
        <div
          data-testid="boarding-pass-email-block"
          class="mr-medium-t border rounded-large nordic-blue-100-border white-bg"
        >
          <fin-expander-card
            #expand
            [title]="'MMB.checkIn.confirmation.email.title' | finLocalization"
            [iconName]="SvgLibraryIcon.EMAIL"
            [expandOpen]="true"
            [hideIconInMobile]="false"
            [descriptionContent]="subTitle"
            [showDescriptionAlways]="true"
            (expandChange)="expand.expandOpen = !expand.expandOpen"
          >
            <ng-container ngProjectAs="expandedContent">
              <div class="ps-medium-x ps-medium-b">
                <fcom-text-input
                  data-testid="checkin-email-input"
                  class="block ms-small-t flex-1"
                  [parentForm]="emailForm"
                  [displayMargin]="false"
                  [translationPrefix]="'paxDetails.fields.email'"
                  [controlName]="'email'"
                  [id]="'email'"
                  [placeHolder]="'paxDetails.fields.email.placeholder'"
                  [displayMargin]="false"
                  [inputType]="InputType.EMAIL"
                />

                <div class="align-right ps-medium-t">
                  <fcom-button
                    [type]="ButtonType.SUBMIT"
                    [mode]="ButtonMode.FILL_MOBILE"
                    [aria]="{
                      disabled: !emailForm.valid || (emailSendingInProgress$ | async) === true,
                      loadingLabel: 'actions.loading' | finLocalization,
                    }"
                    [loading]="(emailSendingInProgress$ | async) === true"
                    [text]="'MMB.checkIn.confirmation.email.send' | finLocalization"
                    (clickBtn)="sendEmail()"
                  />
                </div>
              </div>
            </ng-container>

            <ng-template #subTitle>
              {{ 'MMB.checkIn.confirmation.email.subTitle' | finLocalization }}
            </ng-template>
          </fin-expander-card>
        </div>
      }

      <fin-check-in-boarding-pass-status
        class="block ps-xlarge-t"
        [order$]="order$"
        [bound$]="bound$"
        [passengerIds$]="passengerIds$"
        [isCarrierConnect]="isCarrierConnect$ | async"
      />

      <div
        class="pr-medium-t font-body-1 bold-type"
        *ngIf="'MMB.checkIn.confirmation.links.passengerRights.url' | finHasLocalizationKey"
      >
        <cms-unstyled-fragment
          [contentUrl$]="'MMB.checkIn.confirmation.links.passengerRights.url' | finLocalization | finToObservable"
        />
      </div>

      <fcom-cta-button
        data-testid="manage-booking-check-in-boarding-pass-route-cta-button"
        [title]="'MMB.checkIn.confirmation.backToMmb' | finLocalization"
        [position]="ButtonPosition.GRID_FULL"
        [layout]="ButtonLayout.COLUMN"
        (buttonClicked)="navigateToMmb()"
      />
    </div>
  </div>
</main>
